import React, { useEffect, useState } from "react";
import { Card, CardContent, Box, Button, Tabs, Tab } from "@mui/material";
import * as services from "./../../services/customer";
import * as localServices from "./../../services/local";
import * as salengServices from "./../../services/saleng";
import toast, { Toaster } from "react-hot-toast";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import PersonalInfoForm from "./personal_Info_form";
import PaymentInfoForm from "./persnal_payment_form";
import { useNavigate, useSearchParams } from "react-router-dom";

const { v4: uuidv4 } = require("uuid");

const CustomerForm = () => {
  const [searchParams] = useSearchParams();
  const buy = searchParams.get("buy") === "true";

  const [group, setGroup] = useState("");
  const [personType, setPersonType] = useState("normal");
  // const [cars, setCars] = useState([{ type: "", license: "", province: "" }]);
  const [cars, setCars] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);
  const [customerGroups, setCustomerGroups] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    citizenId: "",
    phone: "",
    address: "",
    img: "",
  });
  const navigate = useNavigate();
  useEffect(() => {
    fetchGroup();
  }, []);
  const fetchGroup = async () => {
    try {
      let res = await services.getGroup();
      const rawData = res.data?.data || [];
      const mapped = rawData.map((group, index) => ({
        id: group.id,
        name: group.name || "-",
      }));
      setCustomerGroups(mapped);
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };
  const readCard = async () => {
    try {
      const res = await localServices.readCard();
      let data = res.data.data;
      setFormData({
        ...formData,
        name: data.firstNameTH + " " + data.lastNameTH,
        dob: data.birthday,
        citizenId: data.citizenId,
        address: data.address,
        img: data.photo,
      });

      console.log("ข้อมูลบัตร:", res.data);
    } catch (err) {
      console.error("err:", err);
      alert("ไม่สามารถอ่านบัตรได้");
    }
  };
  const handleChange = (field) => (event) => {
    setFormData({ ...formData, [field]: event.target.value });
  };

  const handleGroupChange = (event) => {
    setGroup(event.target.value);
  };

  const handleAddCar = () => {
    setCars([...cars, { type: "", license: "", province: "" }]);
  };

  const handleAddDriver = () => {
    setDrivers([...drivers, { name: "", suername: "", idCard: "" }]);
  };

  const handleDeleteCar = (index) => {
    setCars(cars.filter((_, i) => i !== index));
  };

  const handleDeleteDriver = (index) => {
    setDrivers(drivers.filter((_, i) => i !== index));
  };

  const handleCarChange = (index, field, value) => {
    const updatedCars = [...cars];
    updatedCars[index][field] = value;
    setCars(updatedCars);
  };

  const handleDriverChange = (index, field, value) => {
    const updatedDrivers = [...drivers];
    updatedDrivers[index][field] = value;
    setDrivers(updatedDrivers);
  };

  const handleSubmit = async () => {
    try {
      if (formData.img && isBase64(formData.img)) {
        const blob = base64ToBlob(formData.img);
        const form = new FormData();
        form.append("file", blob, "image.png");
        let response = await services.upload(form);
        console.log("response from upload:", response.data);
        formData.img = response.data.file;
      }
      const payload = {
        ...formData,
        personType,
        cars,
        drivers,
        ...(group !== "" && { customerGroupId: Number(group) }),
      };

      const res = await services.createCustomer(payload);
      const data = res.data;
      if (data.success) {
        toast.success("เพิ่มรายการสำเร็จ!");

        if (buy) {
          const customer = data.data;

          const payload = {
            transactionId: uuidv4(),
            customerId: customer.id,
            // carId: customer.cars?.id,
            // driverId: customer.drivers?.id,
            customerName: customer.name,
            status: "waiting",
          };
          const response = await salengServices.createTransaction(payload);
          console.log('response',response);
          navigate(
            `/buy/checkout?id=${response.data.data.transactionId}&ticket=${response.data.data.billNumber}&status=${response.data.data.status}`
          );
        } else {
          navigate(`/buy/customers`);
        }
      } else {
        toast.error(data.error);
      }
    } catch (err) {
      toast.error("เพิ่มรายการไม่สำเร็จ!");
      console.error("Error creating product:", err);
    }
  };
  function isBase64(str) {
    return (
      typeof str === "string" && /^data:image\/[a-zA-Z]+;base64,/.test(str)
    );
  }
  function base64ToBlob(base64, mimeType = "image/png") {
    const byteString = atob(base64.split(",")[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeType });
  }
  const handleTabChange = (_, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <Box p={2}>
      <AppBreadcrumbs />
      <Toaster position="bottom-right" reverseOrder={false} />

      <Box sx={{ maxWidth: 1000, mx: "auto", mt: 4 }}>
        <Card sx={{ mb: 4 }}>
          <CardContent>
            <Tabs value={tabIndex} onChange={handleTabChange} centered>
              <Tab label="ข้อมูลส่วนตัว" />
              <Tab label="การชำระเงิน" />
            </Tabs>

            {tabIndex === 0 && (
              <Box sx={{ mt: 2 }}>
                <PersonalInfoForm
                  formData={formData}
                  handleChange={handleChange}
                  readCard={readCard}
                  customerGroups={customerGroups}
                  group={group}
                  setGroup={setGroup}
                  personType={personType}
                  setPersonType={setPersonType}
                  cars={cars}
                  drivers={drivers}
                  handleAddCar={handleAddCar}
                  handleAddDriver={handleAddDriver}
                  handleDeleteCar={handleDeleteCar}
                  handleDeleteDriver={handleDeleteDriver}
                  handleCarChange={handleCarChange}
                  handleDriverChange={handleDriverChange}
                  // handleSubmit={handleSubmit}
                />
              </Box>
            )}

            {tabIndex === 1 && (
              <Box sx={{ mt: 2 }}>
                <PaymentInfoForm
                  formData={formData}
                  handleChange={handleChange}
                  readCard={readCard}
                  customerGroups={customerGroups}
                  group={group}
                  setGroup={setGroup}
                  personType={personType}
                  setPersonType={setPersonType}
                  cars={cars}
                  handleAddCar={handleAddCar}
                  handleDeleteCar={handleDeleteCar}
                  handleCarChange={handleCarChange}
                  handleDriverChang={handleDriverChange}
                  // handleSubmit={handleSubmit}
                />
              </Box>
            )}
            <Box sx={{ mt: 4, display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
              >
                บันทึกข้อมูล
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default CustomerForm;
